import { getToken } from "js/formatting/getToken";
import config from "config/config";

export async function deletePaymentProfile(useCustomerRefNum) {
  let options = {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `bearer ${getToken()}`,
    },
    body: JSON.stringify({
      PaymentProfileId: useCustomerRefNum,
    }),
  };
  const response = await fetch(
    `${config.REG_API_BASE_URL}/Payment/deletepaymentprofile`,
    options
  );
  if (!response.ok) {
    throw response;
  } else {
    return response;
  }
}
